import React, { useState, useEffect } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Axios } from 'component/base/Axios'
import { useUnmounted } from 'component/hook/useUnmounted'
import Paging from './Paging'

const WithAPI = props => {
  const {
    url,
    disabled,
    keyName,
    valueName,
    textName,
    editOptions,
    value,
    sort,
    params,
    header,
    ...other
  } = props

  const unmounted = useUnmounted()
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState([])
  const [source] = useState(axios.CancelToken.source())

  useEffect(() => {
    if (!url) return
    callApi(url)
  }, [url])

  useEffect(() => {
    if (unmounted.current) source.cancel('your request was canceled')
  }, [unmounted])

  const callApi = async url => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(url, {
      cancelToken: source.token,
      params,
    })
    if (unmounted.current) return

    setLoading(false)

    if (error) {
      setOptions([])
      return
    }
    setOptions(editOptions ? editOptions(data) : edit(data))
  }

  const edit = options =>
    _(options)
      .map(option => ({
        key: option[keyName],
        value: option[valueName],
        text: option[textName],
        ..._.pick(option, sort),
      }))
      .value()

  return (
    <Paging
      {...other}
      value={value}
      options={options}
      disabled={loading || disabled}
      loading={loading}
      selection
      sort={sort}
      header={header}
    />
  )
}

WithAPI.propTypes = {
  url: PropTypes.string.isRequired,
  keyName: PropTypes.string,
  textName: PropTypes.string,
  valueName: PropTypes.string,
  editOptions: PropTypes.func,
  sort: PropTypes.array,
  params: PropTypes.object,
}

WithAPI.defaultProps = {
  keyName: 'key',
  textName: 'text',
  valueName: 'value',
  sort: ['key'],
  params: {},
}

export default WithAPI
